import sellyApi from './sellyApi'

export const getRecipeReviews = async (id) => {
  try {
    const data = await sellyApi.get(`/recipe_reviews/${id}`);
    return data.data;
  } catch (error) {
    return error;
  }
}

export const createRecipeReview = async ({title = '', comment = '', score = '', recipeId, name = '', email = '', userUid = ''}) => {
  try {
    const data = await sellyApi.post(`/recipe_reviews/`, {title, comment, score, recipeId, name, email, userUid});
    return data.data;
  } catch (error) {
    return error;
  }
}

export const getProductReviews = async (id) => {
  try {
    const data = await sellyApi.get(`/producto_reviews/${id}`);
    return data.data;
  } catch (error) {
    return [];
  }
}

export const createProductReviews = async ({title = '', comment = '', score = '', productPlu, name = '', email = '', userUid = ''}) => {
    try {
      const data = await sellyApi.post(`/producto_reviews/`,{title, comment, score, productPlu, name, email, userUid});
      return data.data;
    } catch (error) {
      return error;
    }
  }
  
